/**
 * Mapa único de estados de la Tienda. La interfaz enseña la etiqueta,
 * nunca la clave interna (draft, paid, hero…).
 */

export type StatusTone = 'ok' | 'aviso' | 'critico' | 'neutro';

export interface StoreStatusEntry {
    label: string;
    tone: StatusTone;
}

export const STATUS_TONE_VARIANT = {
    ok: 'success',
    aviso: 'warning',
    critico: 'error',
    neutro: 'neutral',
} as const;

export const STORE_STATUS: Record<string, StoreStatusEntry> = {
    draft: { label: 'Borrador', tone: 'neutro' },
    review: { label: 'En revisión', tone: 'aviso' },
    hero: { label: 'Publicada', tone: 'ok' },
    retired: { label: 'Retirada', tone: 'critico' },
    active: { label: 'Activo', tone: 'ok' },
    inactive: { label: 'Inactivo', tone: 'neutro' },
    sync_fresh: { label: 'Al día', tone: 'ok' },
    sync_stale: { label: 'Sync caducada', tone: 'critico' },
    unsynced: { label: 'Sin sincronizar', tone: 'aviso' },
    published: { label: 'Publicado', tone: 'ok' },
    archived: { label: 'Archivado', tone: 'neutro' },
    approved: { label: 'Aprobado', tone: 'ok' },
    pending: { label: 'Pendiente', tone: 'aviso' },
    rejected: { label: 'Rechazado', tone: 'critico' },
    pending_payment: { label: 'Pendiente pago', tone: 'aviso' },
    paid: { label: 'Pagado', tone: 'ok' },
    processing: { label: 'En preparación', tone: 'aviso' },
    shipped: { label: 'Enviado', tone: 'ok' },
    delivered: { label: 'Entregado', tone: 'ok' },
    completed: { label: 'Completado', tone: 'ok' },
    cancelled: { label: 'Cancelado', tone: 'neutro' },
    refunded: { label: 'Reembolsado', tone: 'critico' },
    seller_confirmed: { label: 'Embalado', tone: 'ok' },
    review_window: { label: 'Por confirmar', tone: 'aviso' },
    incident_open: { label: 'Incidencia', tone: 'critico' },
    queued: { label: 'En cola', tone: 'aviso' },
    running: { label: 'En curso', tone: 'aviso' },
    ok: { label: 'Correcto', tone: 'ok' },
    error: { label: 'Error', tone: 'critico' },
    missing: { label: 'No encontrada', tone: 'aviso' },
    empty: { label: 'Vacía', tone: 'aviso' },
    image_stored: { label: 'Guardada', tone: 'ok' },
    ingest_failed: { label: 'Fallo', tone: 'critico' },
    hotlink: { label: 'Enlace externo', tone: 'aviso' },
};

export function storeStatusLabel(status?: string | null): string {
    if (!status) return 'Sin estado';
    return STORE_STATUS[status]?.label ?? 'Sin estado';
}
